import script from "./MVSGraficaBarras.vue?vue&type=script&setup=true&lang=js"
export * from "./MVSGraficaBarras.vue?vue&type=script&setup=true&lang=js"

import "./MVSGraficaBarras.vue?vue&type=style&index=0&id=2bf77a9f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf77a9f"]])

export default __exports__